import { render } from "./OneProductQuoteComponent.vue?vue&type=template&id=0844b140&scoped=true"
import script from "./OneProductQuoteComponent.vue?vue&type=script&lang=js"
export * from "./OneProductQuoteComponent.vue?vue&type=script&lang=js"

import "./OneProductQuoteComponent.vue?vue&type=style&index=0&id=0844b140&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0844b140"]])

export default __exports__